import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import { round } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { ModalType, useModal } from "@/components/ModalProvider";
import { useGetColorByValue } from "@/pages/diagnosticmonitor/hooks/useGetColorByValue";

interface ChargeRateCellProps {
  props: GridRenderCellParams;
}

export function ChargeRateCell({ props }: ChargeRateCellProps) {
  const { field, value } = props;
  const { precisions } = useDataGridSettings();
  const { t } = useTranslation();
  const formattedValue =
    value !== null ? `${round(value, precisions?.["chargeRate"] ?? 0)} ${t("units.kW")}` : "";

  const [isHovered, setIsHovered] = useState(false);
  const getColorByValue = useGetColorByValue();
  const { bgColor, color } = getColorByValue(field, value);

  const { openModal } = useModal();

  return (
    <Tooltip
      sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      title={formattedValue}
    >
      <Box
        color={value ? color : "#000"}
        sx={{
          backgroundColor: value ? bgColor : undefined,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {!!openModal && isHovered ? (
          <IconButton onClick={() => openModal(props, ModalType.DIAGNOSTIC_DETAILS)}>
            <InfoIcon fontSize="small" />
          </IconButton>
        ) : formattedValue ? (
          formattedValue
        ) : (
          "---"
        )}
      </Box>
    </Tooltip>
  );
}
